<div class="settings-navigation" data-test="settings-navigation">
  <nav mat-tab-nav-bar [mat-stretch-tabs]="false" color="accent" [tabPanel]="tabPanel">
    <a
      *ngIf="isAdvisor$ | async"
      mat-tab-link
      [routerLink]="['/settings', 'finalsetupsetting']"
      [active]="isFinalSetupSetting$ | async"
      data-test="setting-navigation__finalSetup"
    >
      {{ 'settings-navigation.finalsetupsetting' | translate }}
    </a>
    <a mat-tab-link [routerLink]="['/settings', 'barn']" [active]="isBarn$ | async">
      {{ 'settings-navigation.barns' | translate }}
    </a>
    <a
      mat-tab-link
      [routerLink]="['/settings', 'performancesetting']"
      [active]="isPerformance$ | async"
    >
      {{ 'settings-navigation.performance' | translate }}
    </a>
    <a
      mat-tab-link
      [routerLink]="['/settings', 'farmresultsetting']"
      [active]="isFarmResultSetting$ | async"
    >
      {{ 'settings-navigation.farmresultsetting' | translate }}
    </a>
    <a
      *ngIf="isAdvisor$ | async"
      mat-tab-link
      [routerLink]="['/settings', 'discountsetting']"
      [active]="isDiscountSetting$ | async"
      data-test="setting-navigation__discount"
    >
      {{ 'settings-navigation.discountsetting' | translate }}
    </a>
    <a
      *ngIf="showSustainability$ | async"
      mat-tab-link
      [routerLink]="['/settings', 'sustainabilitysetting']"
      [active]="isSustainability$ | async"
    >
      {{ 'settings-navigation.sustainabilitysetting' | translate }}
    </a>
  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
</div>
